let pozicijeSlika = []
pozicijeSlika['levo'] = 0
pozicijeSlika['left'] = 0
pozicijeSlika['centar'] = 1
pozicijeSlika['center'] = 1
pozicijeSlika['desno'] = 2
pozicijeSlika['right'] = 2

export default pozicijeSlika